// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { NamedFragmentDoc } from '../../../../fragments/commonFragments.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type BidScopeFieldsQueryVariables = Types.Exact<{
  projectFilter?: Types.InputMaybe<Types.ProjectFilter>;
}>;


export type BidScopeFieldsQuery = { __typename?: 'Query', projects: Array<
    | { __typename?: 'StandaloneProject', id: string, name: string, children: Array<
        | { __typename?: 'StandaloneProject', id: string, name: string, children: Array<
            | { __typename?: 'StandaloneProject', id: string, name: string }
            | { __typename?: 'Region', id: string, name: string }
            | { __typename?: 'Market', id: string, name: string }
            | { __typename?: 'Community', id: string, name: string }
            | { __typename?: 'Subdivision', id: string, name: string }
            | { __typename?: 'Lot', id: string, name: string }
            | { __typename?: 'Structure', id: string, name: string }
            | { __typename?: 'Unit', id: string, name: string }
          > }
        | { __typename?: 'Region', id: string, name: string, children: Array<{ __typename?: 'Market', id: string, name: string }> }
        | { __typename?: 'Market', id: string, name: string, children: Array<{ __typename?: 'Community', id: string, name: string }> }
        | { __typename?: 'Community', id: string, name: string, children: Array<{ __typename?: 'Subdivision', id: string, name: string }> }
        | { __typename?: 'Subdivision', id: string, name: string, children: Array<{ __typename?: 'Lot', id: string, name: string }> }
        | { __typename?: 'Lot', id: string, name: string, children: Array<{ __typename?: 'Structure', id: string, name: string }> }
        | { __typename?: 'Structure', id: string, name: string, children: Array<{ __typename?: 'Unit', id: string, name: string }> }
        | { __typename?: 'Unit', id: string, name: string, children: Array<
            | { __typename?: 'StandaloneProject', id: string, name: string }
            | { __typename?: 'Region', id: string, name: string }
            | { __typename?: 'Market', id: string, name: string }
            | { __typename?: 'Community', id: string, name: string }
            | { __typename?: 'Subdivision', id: string, name: string }
            | { __typename?: 'Lot', id: string, name: string }
            | { __typename?: 'Structure', id: string, name: string }
            | { __typename?: 'Unit', id: string, name: string }
          > }
      > }
    | { __typename?: 'Region', id: string, name: string, children: Array<{ __typename?: 'Market', id: string, name: string, children: Array<{ __typename?: 'Community', id: string, name: string }> }> }
    | { __typename?: 'Market', id: string, name: string, children: Array<{ __typename?: 'Community', id: string, name: string, children: Array<{ __typename?: 'Subdivision', id: string, name: string }> }> }
    | { __typename?: 'Community', id: string, name: string, children: Array<{ __typename?: 'Subdivision', id: string, name: string, children: Array<{ __typename?: 'Lot', id: string, name: string }> }> }
    | { __typename?: 'Subdivision', id: string, name: string, children: Array<{ __typename?: 'Lot', id: string, name: string, children: Array<{ __typename?: 'Structure', id: string, name: string }> }> }
    | { __typename?: 'Lot', id: string, name: string, children: Array<{ __typename?: 'Structure', id: string, name: string, children: Array<{ __typename?: 'Unit', id: string, name: string }> }> }
    | { __typename?: 'Structure', id: string, name: string, children: Array<{ __typename?: 'Unit', id: string, name: string, children: Array<
          | { __typename?: 'StandaloneProject', id: string, name: string }
          | { __typename?: 'Region', id: string, name: string }
          | { __typename?: 'Market', id: string, name: string }
          | { __typename?: 'Community', id: string, name: string }
          | { __typename?: 'Subdivision', id: string, name: string }
          | { __typename?: 'Lot', id: string, name: string }
          | { __typename?: 'Structure', id: string, name: string }
          | { __typename?: 'Unit', id: string, name: string }
        > }> }
    | { __typename?: 'Unit', id: string, name: string, children: Array<
        | { __typename?: 'StandaloneProject', id: string, name: string, children: Array<
            | { __typename?: 'StandaloneProject', id: string, name: string }
            | { __typename?: 'Region', id: string, name: string }
            | { __typename?: 'Market', id: string, name: string }
            | { __typename?: 'Community', id: string, name: string }
            | { __typename?: 'Subdivision', id: string, name: string }
            | { __typename?: 'Lot', id: string, name: string }
            | { __typename?: 'Structure', id: string, name: string }
            | { __typename?: 'Unit', id: string, name: string }
          > }
        | { __typename?: 'Region', id: string, name: string, children: Array<{ __typename?: 'Market', id: string, name: string }> }
        | { __typename?: 'Market', id: string, name: string, children: Array<{ __typename?: 'Community', id: string, name: string }> }
        | { __typename?: 'Community', id: string, name: string, children: Array<{ __typename?: 'Subdivision', id: string, name: string }> }
        | { __typename?: 'Subdivision', id: string, name: string, children: Array<{ __typename?: 'Lot', id: string, name: string }> }
        | { __typename?: 'Lot', id: string, name: string, children: Array<{ __typename?: 'Structure', id: string, name: string }> }
        | { __typename?: 'Structure', id: string, name: string, children: Array<{ __typename?: 'Unit', id: string, name: string }> }
        | { __typename?: 'Unit', id: string, name: string, children: Array<
            | { __typename?: 'StandaloneProject', id: string, name: string }
            | { __typename?: 'Region', id: string, name: string }
            | { __typename?: 'Market', id: string, name: string }
            | { __typename?: 'Community', id: string, name: string }
            | { __typename?: 'Subdivision', id: string, name: string }
            | { __typename?: 'Lot', id: string, name: string }
            | { __typename?: 'Structure', id: string, name: string }
            | { __typename?: 'Unit', id: string, name: string }
          > }
      > }
  > };


export const BidScopeFieldsDocument = gql`
    query BidScopeFields($projectFilter: ProjectFilter) {
  projects(filter: $projectFilter) {
    ...Named
    children {
      ...Named
      children {
        ...Named
      }
    }
  }
}
    ${NamedFragmentDoc}`;

/**
 * __useBidScopeFieldsQuery__
 *
 * To run a query within a React component, call `useBidScopeFieldsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBidScopeFieldsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBidScopeFieldsQuery({
 *   variables: {
 *      projectFilter: // value for 'projectFilter'
 *   },
 * });
 */
export function useBidScopeFieldsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<BidScopeFieldsQuery, BidScopeFieldsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BidScopeFieldsQuery, BidScopeFieldsQueryVariables>(BidScopeFieldsDocument, options);
      }
export function useBidScopeFieldsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BidScopeFieldsQuery, BidScopeFieldsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BidScopeFieldsQuery, BidScopeFieldsQueryVariables>(BidScopeFieldsDocument, options);
        }
// @ts-ignore
export function useBidScopeFieldsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<BidScopeFieldsQuery, BidScopeFieldsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<BidScopeFieldsQuery, BidScopeFieldsQueryVariables>;
export function useBidScopeFieldsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BidScopeFieldsQuery, BidScopeFieldsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<BidScopeFieldsQuery | undefined, BidScopeFieldsQueryVariables>;
export function useBidScopeFieldsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BidScopeFieldsQuery, BidScopeFieldsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BidScopeFieldsQuery, BidScopeFieldsQueryVariables>(BidScopeFieldsDocument, options);
        }
export type BidScopeFieldsQueryHookResult = ReturnType<typeof useBidScopeFieldsQuery>;
export type BidScopeFieldsLazyQueryHookResult = ReturnType<typeof useBidScopeFieldsLazyQuery>;
export type BidScopeFieldsSuspenseQueryHookResult = ReturnType<typeof useBidScopeFieldsSuspenseQuery>;
export type BidScopeFieldsQueryResult = Apollo.QueryResult<BidScopeFieldsQuery, BidScopeFieldsQueryVariables>;